// hoc/withAuthAndLocale.tsx
import { useAppDispatch } from "@features/store/hooks";
import { setAuthData } from "@features/user/store/thunks/setAuthData";
import { cookieAuthStorageService } from "@features/user/utils/cookieAuthStorageService";
import { ComponentType, FC, useEffect } from "react";

const withAuthSSG = <P extends object>(
  WrappedComponent: ComponentType<P>
): FC<P> => {
  const HOC: FC<P> = (props) => {
    const dispatch = useAppDispatch();

    const token = cookieAuthStorageService.getToken();

    useEffect(() => {
      if (token) {
        dispatch(setAuthData({ token: token }));
      }
    }, [dispatch, token]);

    return <WrappedComponent {...props} />;
  };

  return HOC;
};

export default withAuthSSG;
